import React from 'react'
import isMobileBrowser from 'is-mobile'

import { SidebarModal } from '@domain-group/suit-theme'

const isMobile = isMobileBrowser()

interface ScreenContentProps {
  children: React.ReactNode,
  hasFooter?: boolean,
}

const ScreenContent = (props: ScreenContentProps) => {
  const { children, hasFooter = true } = props

  return (
    <SidebarModal.Content
      boxProps={{ paddingBottom: isMobile ? 206 : 96 }}
      hasFooter={hasFooter}
    >
      {children}
    </SidebarModal.Content>
  )
}

export default ScreenContent
